import angular from 'angular';
import { filter } from 'lodash';

module.exports = angular.module('common.filters.lodash-filter', [])
.filter('lodashFilter', () => filter)
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/lodash-filter.js
 **/